module.exports = __webpack_public_path__ + "media/images/certificates/certificat-03-99c70168d88f492eea5aeeee408c6192.png";